<template>
  <!-- 路由视图 - 这里会显示当前路由对应的组件 -->
    <router-view />
</template>

<script >
import { useRouter } from 'vue-router'
import {login} from '@/api/user.js'
import { showToast } from 'vant';
import { storage } from '@/utils/utils'




export default {
  name: 'App',
  setup() {
    const router = useRouter()
// 获取完整 URL
    const url = window.location.href;
    // 提取 ? 后的参数字符串（兼容 # 路由模式）
    const queryStr = url.split('?')[1]?.split('#')[0] || '';

    // 解析参数为对象
    const params = new URLSearchParams(queryStr);
    const ref = params.get('ref');  // 示例参数名 ref
    const appid = params.get('appid');    // 渠道id
    const appsecret = params.get('appsecret');    // 密码
    const channel_userid = params.get('channel_userid');    // 渠道用户id
    const nickname = params.get('nickname');    // 媒体用户昵称
    const headimgurl = params.get('headimgurl');    // 媒体用户头像

    console.log("appid:"+appid);
    console.log("channel_userid:"+channel_userid);
    console.log("nickname:"+nickname);
    console.log("headimgurl:"+headimgurl);
    if(appid && appid!=localStorage.getItem("channel_userid")){
      localStorage.removeItem('appid');
      localStorage.removeItem('appsecret');
      localStorage.removeItem('channel_userid');
    }
    if(!localStorage.getItem("channel_userid")){
      if(!(appid && channel_userid && nickname && headimgurl)){
        showToast('请提交完整的参数');
      }else{
        localStorage.setItem('appid', appid);
        localStorage.setItem('appsecret', appsecret);
        localStorage.setItem('channel_userid', channel_userid);
        //登录
        login({"nicheng": nickname, "avatarUrl": headimgurl}).then(res=>{
          if(res.code!="200"){
            localStorage.clear();
          }else{
            storage.set('channel_user', res.data);
          }
        });
      }
    }


    const jumpToPage = (ref) => {
      // 根据参数值跳转不同页面
      switch (ref) {
        case 'taskInfo':
          router.push('/taskInfo');
          break;
        case 'taskList':
          router.push('/taskList');
          break;
        default:
          router.push('/taskList');  // 默认跳转首页
      }
    }

    return {
      jumpToPage, ref
    };
  },
  mounted() {
    if (this.ref) {
      this.jumpToPage(this.ref);
    }
  }
}
</script>

<style>
  @import url('@/assets/css/global.css');

</style>
